import { findFirstOccurrence, isArray, stringToDate } from '@hc-frontend/utils'
import { IS_ENROLL } from 'core/constants/environment'
import { DENTAL, LATITUDE, SUPPLEMENTAL_BENEFIT, VISION } from 'core/constants/products'
import getValueFees from 'core/controllerPlans/getValueFees'
import getCorrespondingPolicy from 'core/services/getPlansByProductId/getCorrespondingPolicy'
import getValidatedAddons from 'sites/pivothealth.com/short-term-health-insurance/consumer/quotes/utils/getValidatedAddons'
import isSalesCenterSubDomain from 'utils/pivot/isSalesCenterSubDomain'
import isBTMPlan from 'utils/pivot/plan/isBTMPlan'
import moneyFormat from 'utils/format/money'
import getPremium from 'core/controllerPlans/getPremium'
import getExtendDuration from 'utils/pivot/plan/getExtendDuration'
import getPeriodRange from 'utils/pivot/date/getPeriodRange'

const toMoney = moneyFormat

function calculateTotalProducts({
  plans,
  latitudeId,
  dentalPlanId,
  supplementalId
}): number {
  const dentalPlan = plans[dentalPlanId]
  const latitudePlan = plans[latitudeId]
  const supplementalPlan = plans[supplementalId]
  let totalProducts = 1
  if (dentalPlan) {
    totalProducts += 1
  }

  if (latitudePlan) {
    totalProducts += 1
  }

  if (supplementalPlan) {
    totalProducts += 1
  }

  return totalProducts
}

function applyRules(state) {
  const { filters, plans, planId } = state
  state.renderISCDetails = isSalesCenterSubDomain()

  const plan = plans[planId]

  if (plan) {
    const validatedAddonsByPlan = getValidatedAddons(state)

    state.latitudeAddons = {}
    state.dentalAddons = {}
    state.visionAddons = {}

    state.addonsByPlan = validatedAddonsByPlan
    const addonsByPlan = state.addonsByPlan[planId]

    if (addonsByPlan) {
      const planAddons = addonsByPlan.filter(addonId => {
        const addon = state.plans[addonId]
        return addon && isArray(addon.durations)
      })

      state.latitudeAddons[planId] = findFirstOccurrence(
        planAddons,
        state.plansByType[LATITUDE]
      )
      state.dentalAddons[planId] = findFirstOccurrence(
        planAddons,
        state.plansByType[DENTAL]
      )
      state.visionAddons[planId] = findFirstOccurrence(
        planAddons,
        state.plansByType[VISION]
      )

      state.latitudeId = state.latitudeAddons[state.planId]

      state.dentalPlanId = state.dentalAddons[state.planId]

      state.supplementalId = IS_ENROLL
        ? undefined
        : findFirstOccurrence(state.addOns, state.plansByType[SUPPLEMENTAL_BENEFIT])
    }

    state.totalProducts = calculateTotalProducts({
      plans,
      latitudeId: state.latitudeId,
      dentalPlanId: state.dentalPlanId,
      supplementalId: state.supplementalId
    })

    const isBTM = isBTMPlan(plan)
    const { period, policies } = filters

    const sDate = stringToDate(state.sDate)

    state.periodRange = getPeriodRange({
      extendedDuration: getExtendDuration(plan, period),
      period,
      sDate,
      endDate: state.endDate,
      policies
    })

    const duration = plan.multiCarrierPlan
      ? plan.durations[0]
      : getCorrespondingPolicy({
          plan,
          mainPeriod: period,
          additionalPeriods: state.additionalPeriods,
          policyIndex: policies
        })

    const monthly = duration.monthly
    state.isExtendedPlan = isBTM ? false : +duration.recurrence > 1

    const visionPlan = state.visionAddons[planId]
    const dentalPlan = state.dentalAddons[planId]

    const latitudeCost = getPremium(state.plans[state.latitudeId])

    let visionDentalCost = getPremium(state.plans[state.dentalPlanId])

    if (state.dentalPlanId && !(state.hasDentalActive || state.hasVisionActive)) {
      state.visionPlanId = findFirstOccurrence(addonsByPlan, state.plansByType[VISION])
      visionDentalCost += getPremium(state.plans[state.visionPlanId])
    } else {
      state.visionPlanId = undefined
    }

    state.addOns = [
      state.dentalPlanId,
      state.visionPlanId,
      state.latitudeId,
      state.supplementalId
    ].filter(Boolean)

    state.subscriptionFeeNumber = getValueFees('Application Fee', monthly.fees, 0)

    const planCost = monthly.premium

    const planTitle = state.addOns.reduce(
      (accum, current) => `${accum} + ${state.plans[current].planName}`,
      plan.planName
    )

    const addonsCost = state.addOns.reduce((accum, current) => {
      const plan = state.plans[current]
      return accum + ((plan && plan.durations[0].monthly.premium) || 0)
    }, 0)

    plan.cost = planCost + addonsCost
    plan.title = planTitle

    const dentalVisionTitle = [dentalPlan, visionPlan]
      .filter(Boolean)
      .map(addonId => state.plans[addonId].planName)
      .join(' + ')

    state.dentalVisionTitle = dentalVisionTitle

    state.plan = plan
    state.plans[planId] = plan
    state.isBTM = isBTM

    const total = planCost + visionDentalCost + latitudeCost

    state.prices = {
      plan: toMoney(planCost),
      planNumber: planCost,
      dentalVision: toMoney(visionDentalCost),
      latitude: toMoney(latitudeCost),
      total: toMoney(total),
      bigTotal: toMoney(total + state.subscriptionFeeNumber),
      subscriptionFee: toMoney(state.subscriptionFeeNumber),
      subscriptionFeeNumber: state.subscriptionFeeNumber
    }
  }

  return state
}

export default applyRules
